// removed by extract-text-webpack-plugin
module.exports = {"button":"button__10pZ6","themeCall":"themeCall__1c48f"};


//////////////////
// WEBPACK FOOTER
// ./components/ui/button/style.scss
// module id = j65U
// module chunks = 27